var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.77 13.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.78,2.89l-.53.53-2-2V8H2.51V1.42l-2,2L0,2.89,2.89,0Zm3.46,7.58.53.53L6.88,13.89,4,11l.53-.53,2,2V5.92h.75v6.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapRelationship);
export default __webpack_public_path__ + "static/media/SwapRelationship.5796244ae5963975fd88d41d641a8aef.svg";
export { ForwardRef as ReactComponent };